import { useCallback, useEffect, useRef, useState } from 'preact/hooks';

import { widgetManager } from '../utils';

interface Props {
  isVisible: boolean;
  openWidget: () => void;
  closeWidget: () => void;
  toggleWidget: () => void;
}

export const useWidgetVisibility = (setHasNewMessage?: (value: boolean) => void): Props => {
  const [isVisible, setIsVisible] = useState(false);
  const prevVisibleRef = useRef<boolean | null>(null);

  const openWidget = useCallback(() => {
    setIsVisible(true);
    setHasNewMessage?.(false);
  }, [setHasNewMessage]);

  const closeWidget = useCallback(() => {
    setIsVisible(false);
  }, []);

  const toggleWidget = useCallback(() => {
    setIsVisible((prev) => !prev);
  }, []);

  // callback для программного управления виджетом
  useEffect(() => {
    const handleProgrammaticOpen = (shouldOpen: boolean) => {
      if (shouldOpen && isVisible) {
        return;
      }
      setIsVisible(shouldOpen);
      if (shouldOpen) {
        setHasNewMessage?.(false);
      }
    };

    widgetManager.setInternalVisibilityCallback(handleProgrammaticOpen);

    return () => {
      widgetManager.setInternalVisibilityCallback(undefined);
    };
  }, [isVisible, setHasNewMessage]);

  // Уведомление внешних подписчиков об изменении видимости
  useEffect(() => {
    if (prevVisibleRef.current === null) {
      prevVisibleRef.current = isVisible;
      return;
    }
    if (prevVisibleRef.current !== isVisible) {
      prevVisibleRef.current = isVisible;
      widgetManager.notifyVisibilityChange(isVisible);
    }
  }, [isVisible]);

  return {
    isVisible,
    openWidget,
    closeWidget,
    toggleWidget,
  };
};
